import styled from 'styled-components';

export const TreeWrapper = styled.div`
  flex: 1;
  min-height: 0;
  height: 100%;
  padding: 16px;

  .ant-tree {
    background: transparent;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }

  .ant-tree .ant-tree-node-content-wrapper {
    display: flex;
    align-items: center;
    min-width: 0;
    padding: 0 0 0 6px;
    border-radius: 4px;
  }

  /* O título do antd é um span do tamanho do texto: sem crescer, as ações param
     no fim do nome em vez da borda direita. */
  .ant-tree .ant-tree-title {
    flex: 1;
    min-width: 0;
  }

  /* Scroll horizontal só na lista: hierarquias fundas passam da largura do
     drawer, que não cresce. A lista virtual (rc-virtual-list) só rola na
     horizontal com scrollWidth, que o Tree do antd 5.16 não repassa; o filler
     corta o conteúdo e prende a largura em left/right 0, inline. Soltos os dois,
     o holder rola nativo. Toda linha fica com a largura da mais larga, para as
     ações (sticky) pararem na mesma borda. */
  .ant-tree-list-holder {
    overflow-x: auto;
  }

  .ant-tree-list-holder > div {
    overflow: visible !important;
  }

  .ant-tree-list-holder-inner {
    right: auto !important;
    width: max-content;
    min-width: 100%;
  }

  /* A lista de modelos do federado carrega o CSS GLOBAL do VirtualTreeView (a
     árvore da Autodesk), que fixa 300px na linha e no conteúdo e força a seleção
     transparente. Nossa árvore convive na mesma página, então desfaz aqui. */
  .ant-tree .ant-tree-treenode,
  .ant-tree .ant-tree-node-content-wrapper,
  .ant-tree .ant-tree-node-content-wrapper-open {
    width: 100%;
  }

  .ant-tree .ant-tree-treenode {
    align-items: center;
    padding-bottom: 0;
    border-radius: 4px;
  }

  /* A faixa é a LINHA inteira: o wrapper do conteúdo começa depois da seta e da
     indentação, e pintar só ele deixa a marcação pela metade. O fundo vai no
     treenode, e o wrapper fica transparente para não somar um segundo tom. */
  .ant-tree .ant-tree-treenode:hover {
    background: ${({ theme }) => theme.colors.surface.surfaceContainer};
  }

  .ant-tree .ant-tree-treenode-selected,
  .ant-tree .ant-tree-treenode-selected:hover {
    background: ${({ theme }) => theme.colors.secondary.secondary};
  }

  .ant-tree .ant-tree-node-content-wrapper,
  .ant-tree .ant-tree-node-content-wrapper:hover,
  .ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background: transparent !important;
  }
`;

export const EmptyState = styled.div`
  padding: 24px 16px;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;
